import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ant from 'ant-design-vue'
import Axios from 'axios';  /*引用axios*/
import  qs from 'qs' /*qs序列化*/
import 'ant-design-vue/dist/antd.less'
import '../src/assets/css/base.css' /*引入公共样式*/
import moment from 'moment' /*moment时间格式*/
import "babel-polyfill";
import Echarts from 'echarts'

import LightTimeline from 'vue-light-timeline'; //时间轴插件
import 'lib-flexible/flexible'
/*移动端列表*/
import { Tab, Tabs } from 'vant';
import 'vant/lib/index.css';
Vue.use(Tab);
Vue.use(Tabs);
/*移动端布局*/
import { Col, Row } from 'vant';
Vue.use(Col);
Vue.use(Row);
/*移动端输入框*/
import { Field } from 'vant';
Vue.use(Field);
/*ICON移动端*/
import { Icon } from 'vant';
Vue.use(Icon);
/*移动端加载*/
import { Loading } from 'vant';
Vue.use(Loading);
/*移动端list*/
import { List } from 'vant';
Vue.use(List);
/*移动端单元格*/
import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);
/*移动端日期组件*/
import { DatetimePicker } from 'vant';
Vue.use(DatetimePicker);
//弹出层
import { Picker } from 'vant';
Vue.use(Picker);
/*弹出层*/
import { Popup } from 'vant';
Vue.use(Popup);
/*解决移动端触摸延迟*/
import FastClick from 'fastclick'
FastClick.attach(document.body);
//提示
import { Toast } from 'vant';
Vue.use(Toast);
//  全局过滤器 时间戳
Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD') {
  if (dataStr) {
    return moment(dataStr).format(pattern)
  } else {
    return dataStr
  }
})
/*时间轴插件*/
Vue.use(LightTimeline);
Vue.prototype.$moment = moment;
/*使用ant*/
Vue.use(ant)
/*echarts*/
Vue.prototype.echarts = Echarts
Vue.use(Echarts)
/*axios*/
Vue.prototype.$axios = Axios;
Axios.defaults.headers.post['Content-Type'] = 'application/json';
/*配置qs*/
Vue.prototype.$qs = qs
Vue.config.productionTip = false

import DateUtil from './components/w.tool.date';
Vue.prototype.dateUtil=DateUtil;
//移动端的时间选择插件
import Calendar from 'vue-mobile-calendar'
Vue.use(Calendar)

//全局判断屏幕宽度
const setHtmlFontSize = () => {
  const htmlDom = document.getElementsByTagName('html')[0];
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  if(htmlWidth < 768){
    htmlDom.style.fontSize = `${htmlWidth / 7.5 * 2}px`;
  }
};
window.onresize = setHtmlFontSize;
setHtmlFontSize();

Vue.prototype.screenWidth = document.documentElement.clientWidth || document.body.clientWidth;

//滚动加载数据
import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
